import { Box, Button, chakra, Flex, Image, Text } from '@chakra-ui/react';
import { StrategyListItem } from 'model/modules/strategies/strategies';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

interface Props {
  data: StrategyListItem;
}

const StrategyGridItem: FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation();

  const textShadow = '0px 4px 11px rgba(0, 0, 0, 0.3)';

  const navigate = useNavigate();

  return (
    <AppCard p="0" display="flex" flexDir="column" {...props}>
      <Box
        pos="relative"
        bgColor={Color.Primary500}
        borderTopRadius="16px"
        overflow="hidden"
        h="190px"
      >
        <Image
          position="absolute"
          src={data.image}
          right="0"
          top="0"
          h="100%"
        />
        <Box
          position="absolute"
          left="0"
          top="0"
          zIndex={3}
          w="100%"
          h="100%"
          bgImage="linear-gradient(360deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%)"
        />
        <Flex
          h="100%"
          zIndex={5}
          position="relative"
          flexDir="column"
          justifyContent="flex-end"
          py="15px"
          px="20px"
        >
          <Text
            textShadow={textShadow}
            color={Color.OnPrimary}
            fontWeight={800}
            fontSize="22px"
            mb="5px"
          >
            {data.title}
          </Text>
          <Text
            textShadow={textShadow}
            color={Color.OnPrimary}
            fontWeight={700}
            fontSize="26px"
            mb="5px"
          >
            {data.subtitle1}
          </Text>
          <Text
            textShadow={textShadow}
            color={Color.OnPrimary}
          >
            {data.subtitle2}
          </Text>
        </Flex>
      </Box>
      <Flex
        flex="1"
        px="20px"
        pt="12px"
        pb="20px"
        flexDir="column"
        justifyContent="space-between"
      >
        {data.statistics.map((advantage, index) => {
          return (
            <CardInfoRow
              key={index}
              label={advantage.label}
              showBorder={index < data.statistics.length - 1}
            >
              <Text minW="60px">{advantage.value}</Text>
            </CardInfoRow>
          );
        })}
        <Button
          onClick={() => navigate(AppRoute.strategiesDetail(data.id))}
          w="full"
          mt="16px"
        >
          {t('moreDetails')}
        </Button>
      </Flex>
    </AppCard>
  );
};

export default chakra(StrategyGridItem);
